module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular-Italic.3bf1ad96.woff2";